import "@fortawesome/fontawesome-free/css/all.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "./styles/freya/layout.scss";
import "./styles/freya/theme/theme-dark/blue/theme.scss";
import "./styles/custom-layout.scss";
import "./styles/component-overrides.scss";

import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { store } from "./redux/store";
import {
  ConfirmDialogProvider,
  ToastProvider,
  UiToolkitProvider,
} from "@sl/react-datafabric-components";
import "./App.css";
import ErrorPage from "./common/error/page";
import { ErrorBoundary } from "./common/components/error-boundary";
import { router } from "./router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ErrorBoundary fallback={<ErrorPage />}>
    <PrimeReactProvider value={{ ripple: true, inputStyle: 'outlined' }}>
      <Provider store={store}>
        <UiToolkitProvider>
          <ToastProvider>
            <ConfirmDialogProvider>
              <ErrorBoundary fallback={<ErrorPage />}>
                <RouterProvider router={router} />
              </ErrorBoundary>
            </ConfirmDialogProvider>
          </ToastProvider>
        </UiToolkitProvider>
      </Provider>
    </PrimeReactProvider>
  </ErrorBoundary>
);
